import omertaWebApp from "../config/omertaWebApp.json";

/**
 * Posted to directly in both dev and production: the Apps Script web app answers
 * text/plain POSTs with permissive CORS, so no dev proxy (and no dev-server restart
 * after changing this URL) is needed.
 */
export const omertaRegistrationWebAppUrl = (omertaWebApp.execUrl || "").trim();

export const omertaMeta = {
  id: "omerta-2026",
  name: "Omertà — The Code of Silence",
  shortName: "Omertà",
  tagline: "A live Mafia experience (with a twist)",
  /** Event day — 26 September 2026. */
  date: "2026-09-26",
  venue: "To be disclosed",
  ageNote: "18 yrs and above",
  /** Age cut-off date the DOB rule is measured against. */
  ageAsOnDate: "2026-09-01",
  ageAsOnLabel: "1 September 2026",
  minAgeYears: 18,
  flyerUrl: "/pages/omerta/omerta-flyer.jpeg",
  /** Shown in the drawer's payment block; leave empty to hide the amount line. */
  feeLabel: "\u20B9300",
  /** From the invite — the event runs after dinner. */
  time: "8:30 PM \u2013 11:00 PM (Post Dinner)",
  registrationOpen: false,
  registrationWebAppUrl: omertaRegistrationWebAppUrl,
  /** Optional shared secret — must match SUBMIT_SECRET in scripts/omertaRegistration.gs. */
  registrationSubmitSecret: "",
  helplineWhatsApp: { digits10: "8610447053", display: "86104 47053" },
  /** Shared with every registrant on success — venue and all further updates go here. */
  whatsappGroupUrl: "https://chat.whatsapp.com/F5ovkELJGhsKhumoGxriNZ?mode=gi_t",
};

export const OMERTA_REGISTRATION_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1jkEbNHLgYoCKrwgWL3ku-KqwLxC6ACSduELKsngH7hk/edit";
